import { isImpervaWaitingPath } from '../../modules/landingPages/imperva-waiting-page';

/**
 * Prevents the app from being embedded in a foreign iframe (clickjacking mitigation).
 * Loaded from main.ts instead of an inline script in index.html for CSP compliance.
 * Skipped on /imperva: that page is loaded in a sandboxed iframe without allow-same-origin.
 */
export function initFrameBuster(): void {
  try {
    if (isImpervaWaitingPath()) {
      return;
    }
    if (globalThis.top !== globalThis.self) {
      globalThis.top!.location.href = globalThis.location.href;
    }
  } catch {
    // Opaque/null origin: reading top/parent throws SecurityError.
  }
}
